<!--
 * @Author: Lemon C
 * @Date: 2024-03-27 11:37:22
 * @LastEditTime: 2025-03-13 18:36:10
-->
<template>
    <div class="nav-control-header-body">
        <div class="logo" @click="btn_switch_router({ route: '/home' })">
            <img :src="require(`@/assets/imgs/logo/${state_store.nav_bg_style == 1 ? 'logo_white' : 'logo_black'}.png`)" alt="" />
        </div>
        <div class="menu">
            <ul>
                <li class="menu-item" v-for="(item, index) in menuItems" :key="index" @click="btn_switch_router(item)">
                    <div class="title-box" :class="menuTitle_class_computed(item)">{{ item.name }}</div>
                    <div class="menu-item-active" v-if="item.type === state_store.nav_type"></div>
                </li>
                <li class="menu-item-user" @click="user_click">
                    <div class="user-box" ref="ref_user_box">
                        <div class="login-icon-box">
                            <el-icon v-if="!user_store.loginFlag">
                                <User />
                            </el-icon>
                            <span v-if="user_store.loginFlag">{{ userName_computed }}</span>
                            <div class="user-msg-num" v-if="user_store.loginFlag && user_store.userMsgNum > 0"></div>
                        </div>
                        <div class="user-name" :class="`${state_store.nav_bg_style == 1 ? 'user-name-dark-bg' : 'user-name-light-bg'}`">
                            {{ !user_store.loginFlag ? '登录' : user_store.userName }}
                        </div>
                    </div>
                </li>
                <li class="tran-platform-box">
                    <div class="tran-platform-btn" @click="btn_tran_platform">转换中心</div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue';
import { useUserStore } from '@/stores/user';
import { useStateStore } from '@/stores/state';

const user_store = useUserStore();
const state_store = useStateStore();

const props = defineProps({
    menuItems: Array, //导航数据
    navRouterCallBack: Function, //router跳转
    navTranPlatformCallBack: Function, //转换中心
    navUserCallBack: Function, //用户
});

const ref_user_box = ref(null);
var resizeObserver = null;

const menuTitle_class_computed = computed(() => (item) => {
    let className = '';
    if (state_store.nav_bg_style == 1) {
        className = 'title-box-dark-bg';
    } else {
        className = 'title-box-light-bg';
    }
    if (item.type === state_store.nav_type) {
        if (state_store.nav_bg_style == 1) {
            className = `${className} title-box-dark-active`;
        } else {
            className = `${className} title-box-light-active`;
        }
    }
    return className;
});

const userName_computed = computed(() => {
    let nameChar = user_store.userName.length ? user_store.userName[0].toUpperCase() : '';
    return nameChar;
});

// 初始化监听
onMounted(() => {
    // 创建 ResizeObserver
    resizeObserver = new ResizeObserver((entries) => {
        updatePosition();
    });
    // 监听目标元素和父元素
    if (ref_user_box.value) resizeObserver.observe(ref_user_box.value);
    // 窗口尺寸变化监听
    window.addEventListener('resize', updatePosition);
});

// 清理监听
onUnmounted(() => {
    if (resizeObserver) {
        resizeObserver.disconnect();
    }
    window.removeEventListener('resize', updatePosition);
});

// 更新弹窗位置
const updatePosition = () => {
    if (!ref_user_box.value) return;
    const targetRect = ref_user_box.value.getBoundingClientRect();
    // 计算相对位置
    let user_box = {
        left: targetRect.right - targetRect.width,
        top: targetRect.top,
    };
    state_store.nav_user_box_pos = user_box;
};

// MARK 路由跳转
const btn_switch_router = (item) => {
    props.navRouterCallBack(item);
};
// MARK 转换平台跳转
const btn_tran_platform = () => {
    props.navTranPlatformCallBack();
};
// MARK 用户跳转
const user_click = () => {
    props.navUserCallBack(user_store.loginFlag);
};
</script>

<style lang="less" scoped>
.nav-control-header-body {
    position: fixed;
    display: flex;
    justify-content: space-between;
    align-items: center;
    top: 0px;
    right: 0px;
    width: 100%;
    height: var(--nav-height);
    padding: 0px 48px;
    box-sizing: border-box;
    font-size: 16px;
    z-index: var(--nav-z-index);
    background: var(--color-main-nav-light-bg);
    box-shadow: var(--color-main-nav-shadow);
    // transition: background-color 0.3s linear; /* 添加过渡效果 */

    .logo {
        overflow: hidden;
        cursor: pointer;
        flex-shrink: 0;
        position: relative;
        width: 190px;
        height: 40px;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .menu {
        display: flex;
        justify-content: space-between;
        // margin-top: 22px;
        height: 50px;
        align-items: center;

        ul {
            position: relative;
            height: 100%;
            display: flex;
            z-index: var(--nav-menu-z-index);
            align-items: center;
        }

        li {
            height: 40px;
            cursor: pointer;
        }

        .menu-item {
            position: relative;
            display: flex;
            margin: 0px 44px;
            width: 100px;
            font-size: 20px;

            .title-box {
                position: relative;
                display: flex;
                justify-content: center;
                margin-top: 8px;
                width: 100%;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                font-size: 20px;
                line-height: 24px;
                height: 30px;
                font-weight: 400;
                color: var(--color-main-text-nav-light-bg-default);
            }
            .title-box-light-bg {
                color: var(--color-main-text-nav-light-bg-default);
                &:hover {
                    color: var(--color-main-brand-hover);
                }
            }
            .title-box-dark-bg {
                color: var(--color-main-text-nav-dark-bg-default);
                &:hover {
                    color: var(--color-main-text-nav-dark-bg-default-selected);
                }
            }

            .title-box-light-active {
                color: var(--color-main-text-nav-selected);
            }
            .title-box-dark-active {
                color: var(--color-main-text-nav-dark-bg-default-selected);
            }

            &:hover::after {
                width: 100%;
                left: 0;
            }

            &::after {
                content: '';
                position: absolute;
                width: 0;
                height: 2px;
                background: var(--color-main-brand);
                bottom: 0;
                transition: all 0.8s;
                left: 50%;
            }

            .menu-item-active {
                position: absolute;
                width: 100%;
                height: 2px;
                background: var(--color-main-brand-active);
                bottom: 0;
            }
        }

        .menu-item-user {
            position: relative;
            margin-left: 70px;
            .user-box {
                position: relative;
                display: flex;
                height: 100%;
                align-items: center;

                .login-icon-box {
                    position: relative;
                    width: 28px;
                    height: 28px;
                    background-color: var(--color-main-brand);
                    border-radius: 14px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 18px;
                    color: var(--color-main-border-white);
                    outline: 0 solid transparent;
                    transition: var(--animation-outline-style);

                    span {
                        font-size: 16px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 100%;
                        height: 100%;
                        padding-bottom: 2px; //强制居中，字体限制
                    }

                    .user-msg-num {
                        position: absolute;
                        right: 0px;
                        top: 0px;
                        width: 8px;
                        height: 8px;
                        background-color: var(--color-main-msg-red-bg);
                        border-radius: 4px;
                        display: flex;
                    }

                    &:hover {
                        outline: 4px solid var(--color-main-outline-hover);
                    }
                }

                .user-name {
                    position: relative;
                    max-width: 80px;
                    margin-left: 8px;
                    font-size: 16px;
                    line-height: 28px;
                    font-weight: 500;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                .user-name-light-bg {
                    color: var(--color-main-text-nav-light-bg-default);
                    &:hover {
                        color: var(--color-main-brand-active);
                    }
                }
                .user-name-dark-bg {
                    color: var(--color-main-text-nav-dark-bg-default);
                    &:hover {
                        color: var(--color-main-text-nav-dark-bg-default-selected);
                    }
                }
            }
        }

        .tran-platform-box {
            position: relative;
            display: flex;
            align-items: center;
        }
        .tran-platform-btn {
            position: relative;
            margin-left: 44px;
            width: 96px;
            height: 40px;
            border-radius: 6px;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: var(--color-main-brand);
            color: var(--color-main-text-brand-bg-primary);
            font-weight: 400;
            font-size: 16px;
            line-height: 19px;
            outline: 0 solid transparent;
            transition: var(--animation-outline-style);

            &:hover {
                outline: 4px solid var(--color-main-outline-hover);
            }
        }
    }
}
</style>
